module.exports = __webpack_public_path__ + "img/13.ca83e7ca.svg";